<template>
    <b-modal :visible="value" title="초기화 미리보기" size="md" hide-footer @input="$emit('input', $event)" @hide="$emit('input', false)">
        <div v-if="preview" class="preview-modal-content">
            <div class="preview-info-section">
                <div class="preview-info-item">
                    <span class="preview-info-label">조직 경계</span>
                    <span class="preview-info-value">{{ preview.orgBoundaryName }}</span>
                </div>
                <div class="preview-info-item">
                    <span class="preview-info-label">운영 경계</span>
                    <span class="preview-info-value">{{ preview.operBoundaryName }}</span>
                </div>
            </div>

            <div class="preview-divider"></div>

            <div class="preview-list-section">
                <h6 class="preview-list-title">포함될 시설 ({{ preview.facilityCount }}개)</h6>
                <div class="preview-items">
                    <span v-for="(facility, idx) in preview.facilities" :key="idx" class="preview-tag">
                        {{ facility }}
                    </span>
                    <span v-if="preview.facilityCount > 5" class="preview-more">
                        외 {{ preview.facilityCount - 5 }}개
                    </span>
                </div>
            </div>

            <div class="preview-list-section">
                <h6 class="preview-list-title">포함될 카테고리 ({{ preview.categoryCount }}개)</h6>
                <div class="preview-items">
                    <span v-for="(category, idx) in preview.categories" :key="idx" class="preview-tag">
                        {{ category }}
                    </span>
                    <span v-if="preview.categoryCount > 5" class="preview-more">
                        외 {{ preview.categoryCount - 5 }}개
                    </span>
                </div>
            </div>

            <div class="preview-divider"></div>

            <div class="preview-result-box">
                <div class="preview-result-label">생성될 설정</div>
                <div class="preview-result-value">
                    <span class="preview-total">{{ preview.totalCount }}개</span>
                </div>
                <div class="preview-result-formula">
                    {{ preview.facilityCount }}개 시설 × {{ preview.categoryCount }}개 카테고리
                </div>
            </div>
        </div>
        <div class="modal-footer-compact">
            <CarbonButton @click="$emit('input', false)">닫기</CarbonButton>
            <CarbonButton variant="primary" @click="onExecute">초기화 실행</CarbonButton>
        </div>
    </b-modal>
</template>

<script>
import CarbonButton from "../../common/CarbonButton.vue";

export default {
    name: "ActivityConfigInitializePreviewModal",
    components: { CarbonButton },
    props: {
        value: { type: Boolean, default: false },
        preview: { type: Object, default: null },
    },
    methods: {
        onExecute() {
            this.$emit("execute");
            this.$emit("input", false);
        },
    },
};
</script>

<style scoped>
.preview-modal-content {
    padding: 8px 0;
}

.preview-info-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.preview-info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.preview-info-label {
    font-size: 12px;
    color: #64748b;
}

.preview-info-value {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
}

.preview-divider {
    height: 1px;
    background: #e2e8f0;
    margin: 16px 0;
}

.preview-list-section {
    margin-bottom: 12px;
}

.preview-list-title {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 8px;
}

.preview-items {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.preview-tag {
    padding: 4px 8px;
    background: #f1f5f9;
    border-radius: 4px;
    font-size: 12px;
    color: #475569;
}

.preview-more {
    font-size: 12px;
    color: #94a3b8;
}

.preview-result-box {
    padding: 12px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
}

.preview-result-label {
    font-size: 11px;
    color: #64748b;
    margin-bottom: 4px;
}

.preview-result-value {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
}

.preview-total {
    color: #52b788;
}

.preview-result-formula {
    font-size: 11px;
    color: #94a3b8;
    margin-top: 4px;
}

.modal-footer-compact {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 0 0;
}
</style>
